import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import striptags from "striptags"

import ShareImage from '@static/images/share-image.png'

const PageAttributes = props => {
  const siteName = `MOON Consultants`
  const siteDescription = ``
  const sep = `|`

  const defaultTitle = () => `${siteName}`
  const defaultDescription = () => `${siteDescription}`

  const title = () => {
    return props.title ? `${siteName} ${sep} ${striptags(props.title)}` : defaultTitle()
  }

  const description = () => {
    return props.description ? striptags(props.description) : defaultDescription()
  }

  const image = () => {
    return props.image ? props.image : ShareImage
  }

  return (
    <Helmet
      defaultTitle={defaultTitle()}
      title={title()}
      mateDescription={description()}
    >
      <meta name="description" content={description()} />
      <meta property="og:title" content={title()} />
      <meta property="og:description" content={description()} />
      <meta property="og:image" content={image()} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title()} />
      <meta name="twitter:description" content={description()} />
      <meta name="twitter:image" content={image()} />
    </Helmet>
  )
}

PageAttributes.defaultProps = {
  title: null,
  description: null,
  image: null,
}

PageAttributes.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
}

export default PageAttributes
